import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Button, Card, CardBody, CardHeader, CardFooter } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import moment from 'moment';
import 'moment/locale/es'; // Importar el idioma español 
import BarChart from '../../../../Components/Common/Charts/BarChart';
import { getDashboardEstablishment } from '../../../../slices/thunks';
import BarStackedChart from '../../../../Components/Common/Charts/BarStackedChart';
import OPlaceholder from '../../../../Components/OElements/OPlaceholder';
import getChartColorsArray from '../../../../Components/Common/ChartsDynamicColor';
import { generateColorGradient } from '../../../../Components/Hooks/useColorArrayHooks';

moment.locale('es'); // Configurar el idioma

const PpeEstablishmentInfo = ({ title, dataColors, um = '', establishment_id = null, minHeight, maxHeight }) => {
    const dispatch = useDispatch();
    const [selectedFilter, setSelectedFilter] = useState('1M');


    const selectorPersonalProtectiveEquipment = createSelector(
        state => state.PersonalProtectiveEquipments,
        data => ({
            isLoading: data.isLoadingDashboardEstablishment,
            dashboardEstablishment: data.dashboardEstablishment,
        })
    );

    const { isLoading, dashboardEstablishment } = useSelector(selectorPersonalProtectiveEquipment);


    useEffect(() => {
        dispatch(getDashboardEstablishment({ 'filter': selectedFilter, 'establishment_id': establishment_id }));
    }, []);

    const handleFilterChange = (filter) => {
        setSelectedFilter(filter);
        dispatch(getDashboardEstablishment({ 'filter': filter, 'establishment_id': establishment_id }));
    };

    // Paso 1: obtener lista única de establecimientos y estados
    const labelsChart = [...new Set(dashboardEstablishment.map(item => item.establishment))];
    const statusInfoMap = new Map(); // status -> { bgcolor, txcolor }

    dashboardEstablishment.forEach(item => {
        if (!statusInfoMap.has(item.status)) {
            statusInfoMap.set(item.status, {
                bgcolor: item.bgcolor,
                txcolor: item.txcolor
            });
        }
    });

    const statuses = Array.from(statusInfoMap.keys());

    // Paso 2: inicializar un diccionario para cada status
    const statusMap = {};
    statuses.forEach(status => {
        statusMap[status] = Array(labelsChart.length).fill(0);
    });

    // Paso 3: rellenar los datos por posición
    dashboardEstablishment.forEach(item => {
        const estIndex = labelsChart.indexOf(item.establishment);
        if (estIndex !== -1) {
            statusMap[item.status][estIndex] = item.count;
        }
    });

    // Paso 4: transformar a la estructura final
    const seriesChart = statuses.map(status => ({
        name: status,
        data: statusMap[status]
    }));

    // Paso 5: array de colores (por estado)
    // const colorsChart = statuses.map(status => statusInfoMap.get(status).txcolor);
    const colorsChart = generateColorGradient(4);

    if (isLoading) {
        return <OPlaceholder />;
    }

    return (
        <React.Fragment>
            <Card className='m-0 h-100'>
                <CardHeader className='p-2 align-items-center d-flex'>
                    <h5 className="card-title mb-0 flex-grow-1">{title}</h5>
                    <div className='btn-box-dashboard'>
                        {/* <Button
                            color={selectedFilter === 'AC' ? "primary" : "secondary"}
                            size="sm"
                            className={selectedFilter === 'AC' ? "btn-soft-primary me-1" : "btn-soft-secondary me-1"}
                            onClick={() => handleFilterChange('AC')}
                            title="Ciclo Activo"
                        >
                            CA
                        </Button> */}
                        <Button
                            color={selectedFilter === '1Y' ? "primary" : "secondary"}
                            size="sm"
                            className={selectedFilter === '1Y' ? "btn-soft-primary me-1" : "btn-soft-secondary me-1"}
                            onClick={() => handleFilterChange('1Y')}
                            title="1 Año"
                        >
                            1A
                        </Button>
                        <Button
                            color={selectedFilter === '6M' ? "primary" : "secondary"}
                            size="sm"
                            className={selectedFilter === '6M' ? "btn-soft-primary me-1" : "btn-soft-secondary me-1"}
                            onClick={() => handleFilterChange('6M')}
                            title="6 Meses"
                        >
                            6M
                        </Button>
                        <Button
                            color={selectedFilter === '3M' ? "primary" : "secondary"}
                            size="sm"
                            className={selectedFilter === '3M' ? "btn-soft-primary me-1" : "btn-soft-secondary me-1"}
                            onClick={() => handleFilterChange('3M')}
                            title="3 Meses"
                        >
                            3M
                        </Button>
                        <Button
                            color={selectedFilter === '1M' ? "primary" : "secondary"}
                            size="sm"
                            className={selectedFilter === '1M' ? "btn-soft-primary" : "btn-soft-secondary"}
                            onClick={() => handleFilterChange('1M')}
                            title="1 Mes"
                        >
                            1M
                        </Button>
                    </div>
                </CardHeader>


                {/* Gráfico de stock de combustible */}
                <CardBody className="p-0">
                    <BarChart
                        seriesChart={seriesChart}
                        categoriesChart={labelsChart}
                        colorsChart={colorsChart}
                        toolbarChart={true}
                        height={'100%'}
                        minHeight={minHeight}
                        maxHeight={maxHeight}
                        legendPosition={'bottom'}
                        legendOffsetY={2}
                        strokeCurve={'smooth'}
                        chartType={'bar'}
                        horizontal={false}
                        yAxisTitle={'Cantidad'}
                        um={um}
                    />
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default PpeEstablishmentInfo;
